export default function IconLeftArrow({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11.707 4.29271C11.3409 3.9266 10.7619 3.904 10.3691 4.22435L10.293 4.29271L3.29297 11.2927C2.90244 11.6832 2.90244 12.3162 3.29297 12.7068L10.293 19.7068L10.3691 19.7751C10.7619 20.0955 11.3409 20.0729 11.707 19.7068C12.0731 19.3407 12.0957 18.7617 11.7754 18.3689L11.707 18.2927L6.41406 12.9997H20C20.5523 12.9997 21 12.552 21 11.9997C21 11.4475 20.5523 10.9997 20 10.9997H6.41406L11.707 5.70677L11.7754 5.6306C12.0957 5.23783 12.0731 4.65883 11.707 4.29271Z"
                fill="currentColor"
            />
        </svg>
    );
}
